import {createFileRoute, useParams} from "@tanstack/react-router";

import {routeMessages} from "../../../../../../messages/routes.messages";

import {UserStatisticsPage} from "./-page/user-statistics.page";

// ─── Route definition ─────────────────────────────────────────────────────────

export const Route = createFileRoute("/_app/admin/users/$userId/statistics/")({
  component: RouteComponent,
  staticData: {meta: {labelDescriptor: routeMessages.statistics}},
});

// ─── Route component wrapper ──────────────────────────────────────────────────

function RouteComponent() {
  const {userId} = useParams({strict: false}) as {userId: string};

  return <UserStatisticsPage userId={userId} />;
}
